import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Mail, MapPin, Shield } from "lucide-react";

const COLS = [
  { title: "Company", links: [["About LockMyCollege", "/page/about"], ["Contact", "/page/contact"], ["Careers", "/page/careers"], ["Advertise", "/page/advertise"], ["Partner With Us", "/page/partner"], ["College Listing", "/page/list-your-college"]] },
  { title: "Explore", links: [["All Colleges", "/colleges"], ["MBA", "/mba"], ["PGDM", "/pgdm"], ["Entrance Exams", "/exams"], ["Rankings", "/rankings"], ["News & Updates", "/news"]] },
  { title: "Popular Cities", links: [["MBA in Delhi", "/mba-colleges-in-delhi"], ["MBA in Pune", "/mba-colleges-in-pune"], ["MBA in Bangalore", "/mba-colleges-in-bangalore"], ["MBA in Mumbai", "/mba-colleges-in-mumbai"], ["MBA in Lucknow", "/mba-colleges-in-lucknow"], ["MBA in Hyderabad", "/mba-colleges-in-hyderabad"]] },
  { title: "Legal & Policies", links: [["Editorial Policy", "/page/editorial-policy"], ["Privacy Policy", "/page/privacy"], ["Terms & Conditions", "/page/terms"], ["Cookie Policy", "/page/cookies"], ["Disclaimer", "/page/disclaimer"], ["Sitemap", "/page/sitemap"]] },
];

export function Footer() {
  return (
    <footer className="bg-navy text-white grain">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          <div className="col-span-2 md:col-span-3 lg:col-span-1">
            <Logo variant="light" />
            <p className="mt-4 text-sm text-white/60 leading-relaxed max-w-xs">
              India's premium education discovery platform. Find, compare and lock the right MBA & PGDM college for your future.
            </p>
            <div className="mt-4 space-y-2 text-sm text-white/60">
              <p className="flex items-center gap-2"><Mail size={14} className="text-gold" /> hello@lockmycollege.com</p>
              <p className="flex items-center gap-2"><MapPin size={14} className="text-gold" /> New Delhi, India</p>
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title}>
              <h4 className="text-xs uppercase tracking-widest text-gold mb-4">{col.title}</h4>
              <ul className="space-y-2.5">
                {col.links.map(([label, to]) => (
                  <li key={to}><Link to={to} className="text-sm text-white/70 hover:text-gold transition-colors">{label}</Link></li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-sm text-white/50">
          <p>© {new Date().getFullYear()} LockMyCollege.com — All rights reserved.</p>
          <p className="flex items-center gap-2"><Shield size={14} className="text-gold" /> Data shown is sample/unverified. Always confirm with official sources.</p>
        </div>
      </div>
    </footer>
  );
}
